// @flow

import React, {Component} from 'react'
import IfImg from 'react-if-img'

import Image from './Image'
import MedicineGuide from './MedicineGuide'
import css from './Medicine.css'
import zoomInIcon from '../../../assets/img/zoom-in.svg'

// const placeholder = require('../../../assets/img/medicine-photo.png')

type State = {
  isImageOpen: boolean,
  isGuideOpen: boolean | null,
}
type Props = {
  isMissing: ?boolean,
  name: string,
  intensity: string,
  pharmaceuticalForm: string,
  atc: string,
  activeIncredient: string,
  vnr: string,
  salesPermit: string,
  dimensions: string,
  colour: string,
  storageConditions: string,
  breakline: string,
  markings: string,
  note: string,
  leaflet: string,
  imageUrl: string,
  showMedicineInfo: boolean,
}

class Medicine extends Component {
  state: State = {
    isImageOpen: false,
    isGuideOpen: null,
  }
  props: Props

  openImage = () => {
    this.setState({isImageOpen: true})
  }

  closeImage = () => {
    this.setState({isImageOpen: false})
  }

  toggleGuide = () => {
    this.setState({isGuideOpen: !this.state.isGuideOpen})
  }

  getTitle = () => {
    const {name, intensity, pharmaceuticalForm} = this.props
    return `${name ? name : ''} ${intensity
      ? intensity
      : ''} ${pharmaceuticalForm ? pharmaceuticalForm : ''}`
  }

  render() {
    const {isImageOpen, isGuideOpen} = this.state
    const {
      isMissing,
      atc,
      activeIncredient,
      vnr,
      salesPermit,
      dimensions,
      colour,
      storageConditions,
      breakline,
      markings,
      note,
      leaflet,
      showMedicineInfo,
    } = this.props

    const title = this.getTitle()
    const baseUrl = process.env.IMAGE_URL || ''
    const placeholder = `${baseUrl}/${vnr}.jpg`
    if(isMissing) {
      return (
        <div className={css.component}>
          <div className={css.titleWrapper}>
            <h3 className={css.title}>Tuotetieto puuttuu ({vnr})</h3>
          </div>
        </div>
      )
    }

    return (
      <div className={css.component}>
        {isImageOpen && <Image img={placeholder} closeImage={this.closeImage} />}
        <div className={css.titleWrapper}>
          <div className={css.imageMobile} onClick={() => this.openImage()}>
            <IfImg src={placeholder} alt='Tuotekuva on tulossa' onClick={() => this.openImage()} className={css.medicineImage} />
          </div>
          <h3 className={css.title}>{title}</h3>
        </div>
        <div className={css.wrapper}>
          <div className={css.imageCol}>
            <div className={css.imageWrapper}>
              <div className={css.clickable} onClick={() => this.openImage()}>
                <img className={css.zoomIcon} src={zoomInIcon} alt="" />
                <IfImg src={placeholder} alt='Tuotekuva on tulossa' onClick={() => this.openImage()} className={css.medicineImage} />
              </div>
            </div>
          </div>
          <div className={css.infoCol}>
            <div className={css.infoWrapper}>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>VNR</p>
                  {vnr ? (
                    <p className={css.text}>{vnr}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Vaikuttava aine</p>
                  {activeIncredient ? (
                    <p className={css.text}>{activeIncredient}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Mitat</p>
                  {dimensions ? (
                    <p className={css.text}>{dimensions}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Väri</p>
                  {colour ? (
                    <p className={css.text}>{colour}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Jakouurre</p>
                  {breakline ? (
                    <p className={css.text}>{breakline}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Merkinnät</p>
                  {markings ? (
                    <p className={css.text}>{markings}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Myyntilupa</p>
                  {salesPermit ? (
                    <p className={css.text}>{salesPermit}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Atc</p>
                  {atc ? (
                    <p className={css.text}>{atc}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Säilytysohje</p>
                  {storageConditions ? (
                    <p className={css.text}>{storageConditions}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.element}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Huomioitava</p>
                  {note ? (
                    <p className={css.text}>{note}</p>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              <div className={css.elementLeaflet}>
                <div className={css.elementWrapper}>
                  <p className={css.label}>Pakkausseloste</p>
                  {leaflet ? (
                    <a className={css.link} href={leaflet} target="_blank">
                      <p className={css.text}>Lue pakkausseloste</p>
                    </a>
                  ) : (
                    <p className={css.text}>-</p>
                  )}
                </div>
              </div>
              {showMedicineInfo && (
                <div className={css.more}>
                  <p className={css.link} onClick={() => this.toggleGuide()}>
                    {isGuideOpen ? 'Piilota lisätiedot' : 'Näytä lisätiedot'}
                  </p>
                </div>

              )}
              {(showMedicineInfo && (isGuideOpen !== null)) && <MedicineGuide mounted={this.state.isGuideOpen} vnr={vnr}/>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Medicine



// WEBPACK FOOTER //
// ./src/homepage/components/Medicine.js